import axios from "axios";

export const generateOrder = async ({ restaurantId, supplierId, daysBack }, token) => {
  const response = await axios.post(
    `${process.env.API_URL}/ai/generate/order`,
    null,
    {
      params: { restaurantId, supplierId, daysBack },
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.data;
};
